<template>
    <!-- Login Box -->
    <v-card v-if="!(redirectInfo && isLogged)" flat tile>
        <!-- Login / Sign up Tab -->
        <v-tabs grow hide-slider height="54">
            <v-tab :ripple="false" to="/login">
                {{ $langs.get("auth.login") }}
            </v-tab>
            <v-tab
                :ripple="false"
                to="/register"
                class="primary darken-2 white--text"
            >
                {{ $langs.get("auth.signup") }}
            </v-tab>
        </v-tabs>

        <!-- Login Form -->
        <v-form ref="form" @submit.prevent="submit()" class="py-6 px-8">
            <v-text-field
                class="rounded-sm"
                :label="$langs.get('auth.email')"
                type="email"
                v-model="account.email"
                autocomplete="username"
                :rules="[(v) => !!v || 'required']"
                required
            ></v-text-field>

            <v-text-field
                class="rounded-sm"
                :label="$langs.get('auth.password')"
                :type="showFieldPassword ? 'text' : 'password'"
                v-model="account.password"
                :append-icon="
                    showFieldPassword ? 'visibility' : 'visibility_off'
                "
                @click:append="showFieldPassword = !showFieldPassword"
                autocomplete="current-password"
                :rules="[(v) => !!v || 'required']"
                required
            ></v-text-field>

            <v-checkbox
                v-model="remember"
                :label="$langs.get('auth.keepSignIn')"
                hide-details
                dense
                :ripple="false"
            />

            <v-btn
                block
                depressed
                large
                class="rounded-sm mt-3"
                type="submit"
                color="primary darken-1"
                :loading="isLoading"
                >{{ $langs.get("auth.login") }}</v-btn
            >

            <div class="mt-4 text-center">
                <a
                    :href="`${appMKPUrl}/resetpassword`"
                    class="text-subtitle-2 text-decoration-none"
                >
                    {{ $langs.get("auth.forgetPassword") }}
                </a>
            </div>
        </v-form>
    </v-card>

    <v-card v-else flat tile class="py-6 px-8">
        <h2 class="text-center text-h6">{{ $langs.get("auth.continueTo") }} {{ redirectInfo.name }}</h2>
        <div class="mt-4 text-center text-body-1">{{ $langs.get("auth.withAccount") }}</div>
        <div class="text-center text-body-1">{{ userInfo.email }}</div>
        <v-btn
            block
            depressed
            large
            class="rounded-sm mt-6"
            type="submit"
            color="primary darken-1"
            :loading="isLoading"
            @click="redirect"
        >
            {{ $langs.get("gen.continue") }}
        </v-btn>
        <div class="mt-4 text-center">
            <a href="#" class="text-subtitle-2 text-decoration-none" @click="logout()">
                {{ $langs.get("auth.switchAccount") }}
            </a>
            <span class="mx-3">{{ $langs.get("gen.or") }}</span>
            <a href="/" class="text-subtitle-2 text-decoration-none">
                {{ $langs.get("auth.backToHome") }}
            </a>
        </div>
    </v-card>
</template>

<script>
import { mapState } from "vuex";
import api from "@/services/api";
import user from "@/services/user";
import { userConfig, appMKPUrl, contestAuthUrl, devContestAuthUrl } from "@/services/constants";

const REDIRECT_CONFIG = {
    contest: {
        name: "Contest.Repttown",
        url: contestAuthUrl
    },
    "dev.contest": {
        name: "Dev.Contest.Repttown",
        url: devContestAuthUrl
    }
};

export default {
    props: ["toHome"],
    data() {
        return {
            account: {
                email: "",
                password: "",
            },
            remember: false,
            showFieldPassword: false,
            isLoading: false,

            appMKPUrl: appMKPUrl,

            redirectApp: "",
        };
    },
    mounted() {
        this.remember = user.getConfig(userConfig.KEEP_SIGNIN) || this.remember;
        this.redirectApp = this.$route.query.app;

        setTimeout(() => {
            if (this.redirectInfo) {
                return;
            }
            if (this.isLogged) {
                this.$router.push("/");
            }
        }, 50);
    },
    methods: {
        async submit() {
            if (!this.$refs.form.validate()) return;
            this.isLoading = true;
            const { success, msg } = await this.$store.dispatch({
                type: "Login",
                email: this.account.email,
                password: this.account.password,
                remember: this.remember,
            });
            this.isLoading = false;
            if (success) {
                user.setConfig(userConfig.KEEP_SIGNIN, this.remember);
                api.makeAlert("Login successful.", "primary");

                if (typeof gtag !== 'undefined') {
                    gtag("event", "login", {});
                }

                if (this.redirectInfo) {
                    return;
                }
                if (this.toHome) {
                    return this.$router.push("/");
                }
                this.$router.go(-1);
            } else {
                api.makeAlert(msg, "error");
            }
        },
        async redirect() {
            this.isLoading = true;
            const authToken = await user.createOAuthToken();
            this.isLoading = false;

            if (!authToken) {
                return api.makeAlert("Error while redirecting", "error");
            }

            const redirect = this.$route.query.r;
            window.location.href = `${this.redirectInfo.url}?authToken=${authToken}&r=${redirect}`;
        },
        logout() {
            this.$store.dispatch("Logout");
            api.makeAlert(`You have been logged out.`, 'success');
            setTimeout(() => this.$router.go(), 700);
        },
        makeAlert(color) {
            this.$store.dispatch({
                type: "MakeAlert",
                msg: new Date().toString(),
                color: color,
            });
        },
    },
    computed: {
        ...mapState(["userInfo", "isLogged"]),
        redirectInfo() {
            const to = REDIRECT_CONFIG[this.redirectApp];
            return to || null;
        },
    },
    metaInfo() {
        return {
            title: "Login",
            titleTemplate: "%s · ReptTown",
            meta: [{ name: "robots", content: "noindex" }],
        };
    },
};
</script>

<style scoped lang="scss">
// .tab-active {
//     background: white;
//     &::before {
//         opacity: 0 !important;
//     }
// }
</style>
